export default {
    //阿拉伯语
    DiagnosticReport:'تقرير التشخيص',
    troubleCode:'رمز الخطأ',
    time:'رمز الخطأ',
    noTItle:'التحكم المصنعي',
    TestReport:'تقرير الاختبار',
    VehicleInformation:'معلومات المركبة',
    DataStream:'تيار البيانات',
    IMReadiness:'استعداد I/M',
    Communication:'بروتوكول الاتصال',
    notFaultCode:'لا يوجد رمز عطل',
    nodataflow:'لا يوجد تدفق بيانات غير طبيعي',
    PositioningPrompt:'بدوره على وظيفة لتحديد المواقع للحصول على السعر المحلي .',
    FaultCode:'رمز الخطأ',
    AIDiagnosis:'تشخيص الذكاء الاصطناعي',
    AIWait:'تقرير الذكاء الاصطناعي أو انتظر التشخيص التلقائي',
    FailedFaultCode:'لا يمكن الحصول على معلومات رمز الخطأ',
    AIError:'فشل تحليل الذكاء الاصطناعي',
    more:'المزيد',
    StoredCodes:'تأكيد رمز الخطأ',
    PendingCodes:'انتظر رمز الخطأ',
    PermanentCodes:'رمز الخطأ الدائم',
    ManufacturerControl:'يتم تعريفه من قبل مصنع السيارات',
    continue:'استمر',
    // 引导定位
    notlimits:'لا يمكن الحصول على إذن الموقع',
    setupSteps:'خطوات الإعداد:',
    openset:'افتح تطبيق "الإعدادات"',
    findSet:'العثور على التطبيق الذي تستخدمه',
    clickset:'انقر على "الموقع"',
    selectLimits:'اختر "خلال فترة الاستخدام" أو "دائماً"',
    blackRefresh:'العودة إلى التطبيق لتحديث الصفحة',
    openAppSet:'انقر على "إدارة التطبيقات" أو "التطبيقات"',
    findUseBrowser:'عثر على المتصفح الذي تستخدمه',
    clickAuthority:'انقر على "إدارة الصلاحيات"',
    findejurisd:'ابحث عن إذن "الموقع"',
    selectjurisd:'اختر "السماح" أو "السماح عند الاستخدام"',
    phoneJurisd:'تحقق من إذن تحديد الموقع في تطبيق الهاتف:',
    openJurisd:'تمكين إذن "الموقع"',
    report:'تقرير',
    AI:'AI',
    Freeze:'إطار متجمد',
    VoltageInfo:'معلومات الجهد',
    Voltage:'الجهد الكهربائي',
    Agent:'Agent'
}